import React from 'react';
import PropTypes from 'prop-types';
import Picture from '../../components/Picture';
import SimpleAccordionContainer from '../../components/site/Accordion/SimpleAccordionContainer';
import SimpleAccordionItem from '../../components/site/Accordion/SimpleAccordionItem';


import './CommercialReps.scss';

const DEFAULT_FEATURE_COPY = [
    {
        title: 'App de vendas',
        description: 'Emita pedidos de qualquer lugar pelo celular ou tablet, mesmo offline (Android e iOS)',
    },
    {
        title: 'E-commerce para representantes',
        description: 'Destaque seus produtos por representada, com as condições específicas de cada cliente.',
    },
    {
        title: 'CRM de vendas',
        description: 'Registre históricos e interações com clientes ativos e inativos, por carteira, pasta ou região',
    },
    {
        title: 'Agenda e Roteirização',
        description: 'Planeje visitas e organize o tempo de trabalho, otimizando deslocamento e produtividade',
    },
];

const CommercialReps = ({ imageSrc, imageAlt, titleTag, featureCopy = DEFAULT_FEATURE_COPY }) => {
    const TitleTag = titleTag || 'p';
    return (
    <div className="commercial-reps-section">
        <div className="container">
            <div className="content-wrapper">
                <div className="main-image">
                    <Picture src={imageSrc || "/images/site/new-home/update/reps.png"} alt={imageAlt || "Representante, homem, mexendo no celular, com imagens saindo da tela mostrando o que ele está visualizando: o indicador Carteira de Clientes e um Pedido emitido pelo Mercos"} className="img" />
                </div>
                <div className="features-list">
                    <div className="section-header">
                        <p className="section-overtitle">Produtividade e sucesso comercial</p>
                        <TitleTag className="section-title">Representantes Comerciais</TitleTag>
                        <p className="section-description">Emita pedidos (mesmo offline) com o aplicativo para celular, automatize essa emissão com o Pedidos com IA, venda online e impulsione suas vendas</p>
                    </div>
                    <SimpleAccordionContainer expand='arrow' collapsable>
                        <SimpleAccordionItem title="Venda com praticidade e autonomia">
                            <p>Importe suas planilhas e emita seu primeiro pedido em poucos minutos, sem depender de ninguém</p>
                        </SimpleAccordionItem>
                        <SimpleAccordionItem title="Controle todas as suas representadas">
                            <p>Tenha o controle total das suas representadas, comissões e resultados em uma plataforma pensada para a rotina do representante</p>
                        </SimpleAccordionItem>
                        <SimpleAccordionItem title="Acompanhe informações em tempo real">
                            <p>Pedidos, históricos de clientes, visitas e dados estratégicos sempre à mão, para você decidir com agilidade e vender com segurança</p>
                        </SimpleAccordionItem>
                    </SimpleAccordionContainer>
                </div>
            </div>
            <div className="icon-features">
                {[
                    { icon: '/images/site/icons/smartphone.png', alt: 'App de vendas' },
                    { icon: '/images/site/icons/cart.png', alt: 'E-commerce para representantes' },
                    { icon: '/images/site/icons/graph-arrow-up.png', alt: 'CRM de vendas' },
                    { icon: '/images/site/icons/calendar-clock.png', alt: 'Agenda e Roteirização' },
                ].map((feature, index) => (
                    <div className="icon-feature-item" key={feature.alt}>
                        <div className="icon-wrapper">
                            <Picture loading="lazy" src={feature.icon} alt={feature.alt} />
                        </div>
                        <div className="icon-feature-content">
                            <p className="icon-feature-title">{featureCopy[index].title}</p>
                            <p className="icon-feature-description">{featureCopy[index].description}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </div>
    );
};

CommercialReps.propTypes = {
  imageSrc: PropTypes.string,
  imageAlt: PropTypes.string,
  titleTag: PropTypes.string,
  featureCopy: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
  })),
};

CommercialReps.defaultProps = {
  imageSrc: null,
  imageAlt: null,
  titleTag: 'p',
  featureCopy: DEFAULT_FEATURE_COPY,
};

export default CommercialReps;



// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/TwoCols/CommercialRepsV6.jsx